export default __webpack_public_path__ + "static/media/ISEO CLASS 8 SYLLABUS.45268e00.pdf";